import { useUpgradesStore } from '../../../store/zustand/useUpgradesStore';
import { useCurrencyStore } from '../../../store/zustand/useCurrencyStore';
import { humanNumber } from '@game-libs/exc-libs';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

export const ManaMeterTooltipContent = () => {
  const upgrades = useUpgradesStore((store) => store.upgrades);
  const mana = useCurrencyStore((state) => state.mana);
  const { t } = useTranslation('generators');

  const maxMana = upgrades.wizard.manaPool.multiplier;

  return (
    <>
      <div className={styles.tooltipValue}>
        {t('mana')}: {humanNumber(mana, 0)}/{humanNumber(maxMana, 0)}
      </div>
      <div className={styles.tooltipDescription}>{t('manaDescription')}</div>
      {mana <= 0 && <div className={styles.tooltipDescription}>{t('emptyManaDescription')}</div>}
    </>
  );
};
